import { render, staticRenderFns } from "./MultiLangTextarea.vue?vue&type=template&id=864035be&scoped=true"
import script from "./MultiLangTextarea.vue?vue&type=script&lang=js"
export * from "./MultiLangTextarea.vue?vue&type=script&lang=js"
import style0 from "./MultiLangTextarea.vue?vue&type=style&index=0&id=864035be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864035be",
  null
  
)

export default component.exports